import kitap1 from 'assets/img/home/raf/kitap1.jpg';
import kitap2 from 'assets/img/home/raf/kitap2.jpg';
import kitap3 from 'assets/img/home/raf/kitap3.jpg';
import kitap4 from 'assets/img/home/raf/kitap4.jpg';
import kitap5 from 'assets/img/home/raf/kitap5.jpg';
import kitap6 from 'assets/img/home/raf/kitap6.jpg';
import kitap7 from 'assets/img/home/raf/kitap7.jpg';
import kitap8 from 'assets/img/home/raf/kitap8.jpg';
import modOku from 'assets/img/home/mod-oku.png';
import modDinle from 'assets/img/home/mod-dinle.png';
import modKaydet from 'assets/img/home/mod-kaydet.png';
import modDegerlendir from 'assets/img/home/mod-degerlendir.png';
import modMateryal from 'assets/img/home/mod-materyal.png';

const IMAGEKIT_WEB = 'https://ik.imagekit.io/mvnw0kw1mga/web/';

// ImageKit resizes on the fly via the `tr` query parameter.
export const ik = (name, width) => `${IMAGEKIT_WEB}${name}.png?tr=w-${width}`;
// srcset for the same ImageKit image at several widths, so phones don't download desktop sizes.
// Small images served from public/img: under CRA's 10 KB limit they would be
// inlined as base64 and repeated in the prerendered HTML.
export const LOGO_SRC = '/img/logo-nav.png';
export const APPSTORE_BADGE_SRC = '/img/badge-appstore.png';
export const PLAYSTORE_BADGE_SRC = '/img/badge-playstore.png';

export const ikSet = (name, widths) =>
  widths.map((w) => `${ik(name, w)} ${w}w`).join(', ');

// Height of each ImageKit screenshot at 900px width, so <img> can reserve its
// space (width/height) and request the size it is actually shown at.
export const IK_HEIGHT_AT_900 = {
  ipad_read: 652,
  sozluk: 3102,
  listen: 601,
  rec: 897,
  ipad_pro_11_home: 652,
  message: 1445,
  quiz: 618,
  gorev: 652,
  rapor: 910,
  ogretmen_header: 593,
  ogrenim: 686,
  document: 896,
  newassignment: 770,
  gorev_durumu: 770,
  sinif_raporu: 910,
  sinif_raporu_listesi: 1125,
  iphone: 444,
};

export const STORE_LINKS = {
  okul: {
    appStore: 'https://apps.apple.com/tr/app/okuma-platformu-okul/id6444416015',
    googlePlay:
      'https://play.google.com/store/apps/details?id=com.edictdigital.okumaplatformu',
  },
  bireysel: {
    appStore:
      'https://apps.apple.com/tr/app/okuma-platformu-bireysel/id1662102559',
    googlePlay:
      'https://play.google.com/store/apps/details?id=com.edictdigital.okumaplatformustudent',
  },
};

export const SOCIAL_LINKS = [
  {
    key: 'linkedin',
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/okuma-platformu',
  },
  {
    key: 'facebook',
    label: 'Facebook',
    href: 'https://www.facebook.com/okumaplatformu',
  },
  {
    key: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/okuma_platformu',
  },
  {
    key: 'youtube',
    label: 'YouTube',
    href: 'https://www.youtube.com/@okumaplatformu_',
  },
];

export const NAV_LINKS = [
  { href: '/#uygulamalar', label: 'Uygulamalar' },
  { href: '/#sss', label: 'SSS' },
];

// Definition sentence after the brand name; shown on the home page and reused
// verbatim in llms.txt so answer engines quote the same text.
export const QUICK_FACT =
  "okul öncesi ve ilkokul öğrencileri için dijital okuma platformudur. 13 seviyeli Okuma Ağacı serisindeki 200+ sesli, resimli hikâye; ses temelli okuma için Ses Bilgisi modülü, sözlük, ses kaydı, değerlendirme ve öğretmen görevleriyle web, iOS ve Android'de kullanılır.";

export const HERO_CHIPS = [
  'Okul öncesi ve ilkokul',
  '200+ hikâye',
  '13 okuma seviyesi',
  'Sesli kitap',
  'MEB kazanımlarıyla ilişkili',
];

export const BOOK_COVERS = [
  { src: kitap1, title: 'Pazarda' },
  { src: kitap2, title: 'Küçük Misafir' },
  { src: kitap3, title: 'Merhaba Çengel' },
  { src: kitap4, title: 'Çengel' },
  { src: kitap5, title: "Deniz Müzesi'nde" },
  { src: kitap6, title: 'Şanssız Balıkçılar' },
  { src: kitap7, title: 'Teleferikte Panik' },
  { src: kitap8, title: 'Kapadokya' },
];

// Level labels and colours follow the Okuma Ağacı illustration.
export const LEVELS = [
  { label: '1', color: '#FFD43B', ink: '#3b2f00' },
  { label: '1+', color: '#FFD43B', ink: '#3b2f00' },
  { label: '2', color: '#F48FB1', ink: '#4a1027' },
  { label: '2+', color: '#F8BBD0', ink: '#4a1027' },
  { label: '3', color: '#F7931E', ink: '#3d1f00' },
  { label: '3+', color: '#F7931E', ink: '#3d1f00' },
  { label: '4', color: '#8BC34A', ink: '#1f3a05' },
  { label: '5', color: '#6FA8DC', ink: '#0b2a4a' },
  { label: '6', color: '#1BA5A5', ink: '#04302f' },
  { label: '7', color: '#8E7CC3', ink: '#1c1240' },
  { label: '8', color: '#1565C0', ink: '#ffffff' },
  { label: '9', color: '#D63384', ink: '#ffffff' },
  { label: '10', color: '#D32F2F', ink: '#ffffff' },
];

export const MODES = [
  {
    title: 'Oku',
    image: modOku,
    text: 'Kendi hızında, sayfa sayfa oku. Bilmediğin kelimeye dokun, sözlükte gör.',
  },
  {
    title: 'Dinle',
    image: modDinle,
    text: 'Seslendirmeyi dinlerken kelime ve cümleler sırayla vurgulanır.',
  },
  {
    title: 'Kaydet',
    image: modKaydet,
    text: 'Okurken sesini kaydet; öğretmenine gönder, sevdiklerinle paylaş.',
  },
  {
    title: 'Değerlendir',
    image: modDegerlendir,
    text: 'Okuduğunu anlama, söz varlığı ve tür analizi soruları.',
  },
  {
    title: 'Materyal',
    image: modMateryal,
    text: 'Kitaba özel etkinlikler ve çalışma kâğıtlarıyla pekiştir.',
  },
];

// Letter tiles for the Ses Bilgisi visual; colours follow the level palette.
export const PHONICS_LETTERS = [
  { letter: 'e', color: '#FFD43B', ink: '#3b2f00' },
  { letter: 'l', color: '#F48FB1', ink: '#4a1027' },
  { letter: 'a', color: '#F7931E', ink: '#3d1f00' },
  { letter: 'k', color: '#8BC34A', ink: '#1f3a05' },
  { letter: 'i', color: '#6FA8DC', ink: '#0b2a4a' },
  { letter: 'n', color: '#6B5BD6', ink: '#ffffff' },
];

export const PHONICS_FEATURES = [
  {
    icon: '📚',
    title: 'Ses Bilgisi kitapları',
    text: 'Okul öncesi ve 1. sınıf öğrencilerinin kitaplığında, ses temelli okuma yöntemine uygun kitaplar.',
  },
  {
    icon: '🔤',
    title: 'Harf harf ses materyalleri',
    text: 'Bir ya da birkaç ses seçin; pano ve kartlar, sınıf içi çalışmalar, ölçme ve değerlendirme araçlarından dilediklerinizi ekleyin.',
  },
  {
    icon: '🖨️',
    title: 'Sıralayın, PDF olarak indirin',
    text: 'Sayfaları istediğiniz sırayla düzenleyin, tek tıkla PDF oluşturun; “Ses Materyallerim” listesinden yeniden indirin.',
  },
];

// size: 'wide' spans two columns, 'tall' spans two rows, 'full' the whole row.
// fit: 'cover' for photos, otherwise the screenshot is contained.
export const STUDENT_FEATURES = [
  {
    title: 'Kullanıcı Dostu Arayüz',
    text: 'Dinleme, ses kaydetme, not ekleme, sözlük ve yakınlaştırma sayesinde eşsiz bir okuma deneyimi.',
    image: 'ipad_read',
    size: 'wide',
    tint: '#FFF1DC',
  },
  {
    title: 'Sözlük',
    text: 'Kitaptaki kelimeler, tek dokunuşla anlamıyla.',
    list: [
      "Sayfa'dan kelimeler",
      'Atasözleri ve deyimler',
      'Birden fazla anlam',
      'Örnek cümle',
      'Resimli veya videolu anlatım',
    ],
    image: 'sozluk',
    size: 'tall',
    tint: '#E8F4FF',
  },
  {
    title: 'Sesli Kitaplar',
    text: 'Dinleme esnasında kelime ve cümle takibi.',
    image: 'listen',
    fit: 'cover',
    tint: '#FDEBD3',
  },
  {
    title: 'Ses Kayıt',
    text: 'Okurken sesini kaydet. Öğretmenine gönder, sevdiklerinle paylaş, cihazına indir.',
    image: 'rec',
    tint: '#F1EEFF',
  },
  {
    title: 'Çocuklar İçin Eğlenceli Tasarım',
    text: 'Görevler, kitaplar ve mesajlar; çocukların keşfetmeyi sevdiği bir evrende.',
    image: 'ipad_pro_11_home',
    size: 'wide',
    tint: '#E9ECFF',
  },
  {
    title: 'Mesaj',
    text: 'Öğretmenden gelen yazılı veya sesli mesajları görüntüle.',
    image: 'message',
    size: 'tall',
    tint: '#E6F0FF',
  },
  {
    title: 'Değerlendirme',
    text: 'Okuma anlama, söz varlığı ve tür analizi gelişimini kontrol et.',
    image: 'quiz',
    fit: 'cover',
    tint: '#F5EBDD',
  },
  {
    title: 'Görev',
    text: 'Öğretmenin verdiği okuma, dinleme, oku-kaydet, değerlendirme ve materyal görevlerini teslim tarihinden önce tamamla.',
    image: 'gorev',
    tint: '#FFF4D6',
  },
  {
    title: 'Rapor',
    text: 'Gelişimini takip et: okuduğun, dinlediğin ve kaydettiğin her kitap raporunda.',
    image: 'rapor',
    size: 'full',
    tint: '#E3F7F3',
  },
];

export const TEACHER_FEATURES = [
  {
    title: 'Kolay Kullanım',
    text: 'Kullanıcı bazlı yetkilendirme ile her öğretmen yetkisi kadar menü görüntüler.',
    image: 'ogretmen_header',
    size: 'wide',
    tint: '#EEEBFF',
  },
  {
    title: 'Öğrenim',
    text: 'MEB kazanımları ile ilişkilendirilmiş kitaplar, öğrenim materyalleri ve kitaplara özel ders planları.',
    image: 'ogrenim',
    tint: '#E8F4FF',
  },
  {
    title: 'Materyal',
    text: 'Yüzlerce öğrenim materyali. Derste kullan veya ev ödevi olarak görev ata.',
    image: 'document',
    tint: '#FFF1DC',
  },
  {
    title: 'Görevler',
    text: 'Okuma, dinleme, oku-kaydet, değerlendirme ve materyal içeren görevler oluştur.',
    image: 'newassignment',
    tint: '#F1EEFF',
  },
  {
    title: 'Görev Takip',
    text: 'Görevlerin tamamlanma durumlarını takip et. Öğrenciden gelen okuma kayıtlarını dinle.',
    image: 'gorev_durumu',
    tint: '#E3F7F3',
  },
  {
    title: 'Sınıf Raporu',
    text: 'Sınıfın genel durumunu ve gelişimini grafiklerle takip et.',
    image: 'sinif_raporu',
    size: 'wide',
    tint: '#EEEBFF',
  },
  {
    title: 'Sınıf Listesi',
    text: 'Her öğrencinin okuma, dinleme ve değerlendirme sonuçları tek tabloda.',
    image: 'sinif_raporu_listesi',
    tint: '#FFF1DC',
  },
];

export const FAQ = [
  {
    q: 'Okuma Platformu kimler için?',
    a: 'Okul öncesi ve ilkokul öğrencileri, öğretmenleri ve okullar için. Okul hesabı olmayan aileler Okuma Platformu Bireysel uygulamasını kullanabilir.',
  },
  {
    q: 'Hangi sınıflar için uygun?',
    a: 'Okul öncesi ve ilkokul öğrencileri için uygundur. Okuma Ağacı serisi seviyelere ayrıldığı için her çocuk kendi seviyesinden başlar; Ses Bilgisi modülü okul öncesi ve 1. sınıflar içindir.',
  },
  {
    q: 'Okul hesabımla nasıl giriş yaparım?',
    a: 'Sağ üstteki “Giriş Yap” düğmesine tıklayın ve okulunuzun verdiği kullanıcı adı ile şifreyi girin. Öğrenciler kitaplarına ve görevlerine, öğretmenler ise doğrudan öğretmen paneline yönlendirilir.',
  },
  {
    q: 'Okul hesabını nasıl alırım, kurulum gerekiyor mu?',
    a: 'Kurulum gerekmez; platform web tarayıcısından ve mobil uygulamalardan çevrim içi kullanılır. Okul hesaplarınızı kurumunuzdan talep edebilirsiniz.',
  },
  {
    q: 'Şifremi unuttum, ne yapmalıyım?',
    a: 'Giriş ekranındaki “Şifremi Unuttum” bağlantısını kullanın; e-posta adresinize yeni şifre oluşturma bağlantısı gönderilir.',
    link: { href: '/forgot-password', label: 'Şifremi Unuttum' },
  },
  {
    q: 'Hangi cihazlarda kullanılabilir?',
    a: 'Web tarayıcısından bilgisayarda, ayrıca iPad, iPhone ve Android cihazlarda mobil uygulamalarla kullanılır. Platforma 7/24 çevrim içi erişebilirsiniz.',
  },
  {
    q: 'Ses Bilgisi (ses temelli okuma) modülü nedir?',
    a: 'Okul öncesi ve 1. sınıflar için ses temelli okuma yöntemine uygun kitaplardan ve öğretmenlerin seçtikleri seslere göre hazırlayıp PDF olarak indirebildiği sınıf materyallerinden oluşan yeni modülümüzdür. Okulunuz için etkinleştirildiğinde ilgili öğrenci ve öğretmen hesaplarında görünür.',
    link: { href: '/contact', label: 'Bilgi alın' },
  },
  {
    q: 'Okuma Ağacı nedir?',
    a: 'Okul öncesi ve ilkokul öğrencilerine yönelik, 13 seviyeye ayrılmış 200+ hikâyeden oluşan okuma serisidir. Kerem, Bezgin ve Çengel’in maceraları bu seride.',
  },
  {
    q: 'Kitaplar MEB kazanımlarıyla ilişkili mi?',
    a: 'Evet. Kitaplar MEB kazanımları ile ilişkilendirilmiştir; öğretmenler kazanımlara göre kitap filtreleyebilir, kitaplara özel ders planı ve materyallere ulaşabilir.',
  },
  {
    q: 'Öğretmenler hangi raporları görür?',
    a: 'Sınıf raporu ve sınıf listesiyle sınıfın genel durumunu ve gelişimini izler, görev takibiyle görevlerin tamamlanma durumunu görür ve öğrencilerden gelen okuma kayıtlarını dinleyebilir.',
  },
  {
    q: 'Okuma Platformu ücretli mi?',
    a: 'Okullar için kullanım, okulunuza özel hazırlanan teklifle sağlanır. Okuma Platformu Bireysel uygulaması abonelikle kullanılır ve deneme süresi sunar.',
  },
  {
    q: 'Okulum için nasıl satın alabilirim?',
    a: 'Satın alma formunu doldurun; ekibimiz okulunuza özel teklifle size dönüş yapsın.',
    link: { href: '/buy-now', label: 'Teklif İste' },
  },
  {
    q: 'Öğrenci verileri nasıl korunuyor?',
    a: 'Kişisel verilerin işlenmesine ilişkin tüm ayrıntılar KVKK Aydınlatma Metni’nde yer alır.',
    link: { href: '/kvkk', label: 'KVKK Aydınlatma Metni' },
  },
];
